import styled from 'styled-components';
import { Link } from 'react-router-dom';
import { colors, layout } from '@prisjakt/ui-base';

import Button from '@prisjakt/ui-button';

export const MenuButton = styled.span`
  cursor: pointer;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  text-align: right;
  color: #fff;

  &:focus {
    outline: none;
  }

  &:hover {
    color: #fff;
  }
`;

export const Buttons = styled.div`
  display: flex;
  flex-direction: column;
  text-align: center;
  padding: ${layout.spacing.small};
`;

export const AccountButton = styled(Button)`
  width: 100%;

  &:not(:last-child) {
    margin-bottom: ${layout.spacing.xSmall};
  }
`;

export const SignupLink = styled(Link)`
  color: ${colors.lightBlue3};
  text-decoration: underline;

  &:hover {
    color: ${colors.lightTheme.maybeBlue500};
  }
`;
